<template>
  <segment-page></segment-page>
</template>

<script>
import SegmentPage from '@/modules/audiences/pages/SegmentPage'
export default {
  name: 'SegmentUpdatePage',
  components: { SegmentPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SegmentPageUpdate.vue